// Module
var code = "<div class=\"edit-flow-model-container\" ng-if=\"$ctrl.canEdit\"> <label class=\"btn small white-text\" ng-click=\"$ctrl.onEditOrViewFlowModelClick()\"> {{$ctrl.canEdit == true ? \"Edit\" : \"View\"}} Flow Model </label> </div> ";
// Exports
export default code;